module.exports = __webpack_public_path__ + "static/media/rider.71b438aa.jpg";